// Dependencies
import React, { Component } from 'react';
import IdleTimer from 'react-idle-timer';

// Primereact imports
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';

// Styling
import './app-header.scss';

// Multi Lang
import { withTranslation } from 'react-multi-lang';
import { setLanguage } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';
import { clearUserParameters } from '../../redux/actions/authentication';
import { changeAppLanguage } from '../../redux/actions/profile';

// Utils
import { checkPublicPage } from '../../common/utils/page-utils';

class AppHeader extends Component {

    logout() {
        this.props.clearUserParameters();
        setTimeout(() => window.open(process.env.REACT_APP_OF_SITE_URL + "?hideinar=false","_self"), 1000);
    }

    setLanguage(language) {
        setLanguage(language);
        this.props.changeAppLanguage(language);
    }

    render() {
        let idleTimerRef = React.createRef();
        return (
            checkPublicPage(window.location.href) === false ?
                <div className="grid" style={{minHeight:"63px", alignItems:"center"}}>
                    <IdleTimer
                        ref={idleTimerRef}
                        element={document}  
                        onIdle={(evt) => {
                            this.logout();
                        }}
                        debounce={250}
                        timeout={Number(process.env.REACT_APP_IDLE_TIMEOUT)} />
                    <div className="col-1"></div>
                    <div className="col-10 md:col-6 lg:col-7 t-align-right mgt-15">
                        <span style={{fontSize: "12px", marginRight: "10px", color: "#0073aa"}} className='c-pointer' onClick={() => this.setLanguage('pt')}>PT</span>
                        <span style={{fontSize: "12px", marginRight: "10px", color: "#0073aa"}} className='c-pointer' onClick={() => this.setLanguage('en')}>EN</span>
                        <span style={{fontSize: "12px", marginRight: "10px", color: "#0073aa"}} className='c-pointer' onClick={() => this.setLanguage('es')}>ES</span>
                        <span style={{fontSize: "12px", marginRight: "10px", color: "#0073aa"}} className='c-pointer' onClick={() => this.setLanguage('fr')}>FR</span>
                    </div>
                    <div className="col-12 md:col-2 lg:col-3 t-align-right mgt-15">
                        <span style={{fontWeight:"bold", fontSize: "12px", marginRight: "10px", color: "#0073aa"}}>
                            {
                                this.props.userId !== null ?
                                    <>
                                        <Avatar style={{marginRight:"10px"}} label={this.props.associate !== null && this.props.associate.personalData !== null ? this.props.associate.personalData.name.charAt(0) : ""} size="large" shape='circle'  />
                                        <span style={{fontSize: "13px", marginRight: "10px"}}>{this.props.associate !== null && this.props.associate.personalData !== null ? this.props.associate.personalData.professionalName != null ? this.props.associate.personalData.professionalName : this.props.associate.personalData.name : ""}</span>
                                    </>
                                    : null
                            }
                            {
                                this.props.userId !== null ?
                                    <Button label={this.props.t("general.logout")} icon="pi pi-sign-out" className="logout-btn c-pointer" onClick={() => this.logout()} />
                                    :
                                    <Button label={this.props.t("general.back")} icon="pi pi-arrow-left" className="logout-btn c-pointer" onClick={() =>  window.open(process.env.REACT_APP_SITE_PUBLIC_STORE_URL, "_self")} />
                            }
                        </span>
                    </div>
                    <div className="col-1"></div>
                </div>
                : null
        );
    }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        userId: state.authentication.userId,
    } 
  };

const mapDispatchToProps = (dispatch) => {
    return {
        clearUserParameters: () => { dispatch(clearUserParameters()) },
        changeAppLanguage: (language) => { dispatch(changeAppLanguage(language)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(AppHeader));